/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ArenasRestricted,
  ArenasRestrictedInterface,
  ArenasConstructor,
} from "../ArenasRestricted";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "alphadune",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            internalType: "uint256",
            name: "alphadunePercentage",
            type: "uint256",
          },
        ],
        internalType: "struct ArenasConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        indexed: false,
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "EditArena",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        indexed: false,
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "NewArena",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "arena",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        internalType: "struct Arena.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "arenaOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "arenas",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "token_uri",
        type: "string",
      },
      {
        internalType: "address",
        name: "platformAndArenaFeeCurrency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "platformAndArenaFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "arenaMap",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "surface",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "distance",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "weather",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "restricted",
        type: "address",
      },
      {
        internalType: "address",
        name: "methods",
        type: "address",
      },
      {
        internalType: "address",
        name: "payments",
        type: "address",
      },
      {
        internalType: "address",
        name: "alphadune",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "alphadunePercentage",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "createArena",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "editArena",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "id",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "platformAndArenaFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "platformAndArenaFeeCurrency",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "alphadune",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            internalType: "uint256",
            name: "alphadunePercentage",
            type: "uint256",
          },
        ],
        internalType: "struct ArenasConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ArenasRestrictedConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ArenasRestrictedConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ArenasRestricted__factory extends ContractFactory {
  constructor(...args: ArenasRestrictedConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ArenasRestricted";
  }

  deploy(
    input: ArenasConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ArenasRestricted> {
    return super.deploy(input, overrides || {}) as Promise<ArenasRestricted>;
  }
  getDeployTransaction(
    input: ArenasConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): ArenasRestricted {
    return super.attach(address) as ArenasRestricted;
  }
  connect(signer: Signer): ArenasRestricted__factory {
    return super.connect(signer) as ArenasRestricted__factory;
  }
  static readonly contractName: "ArenasRestricted";
  public readonly contractName: "ArenasRestricted";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ArenasRestrictedInterface {
    return new utils.Interface(_abi) as ArenasRestrictedInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ArenasRestricted {
    return new Contract(address, _abi, signerOrProvider) as ArenasRestricted;
  }
}
